<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <a-button type="primary" @click="openAddDrawer" style="margin-right:15px;">上传SQL文件</a-button>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:20px;"
      ref="table"
      size="default"
      rowKey="sql_id"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="sql_type" slot-scope="text">
        {{ text | valInDict(dict.sqlTypeDict) }}
      </span>
      <span slot="log_count" slot-scope="text, record">
        <a style="color:#ffffff;border-bottom: 1px solid;" @click="openLogDrawer(record)"><span style="color:#04f304">{{ record.success_log_count }}</span> / <span style="color:#f91707">{{ record.fail_log_count }}</span> / {{ record.log_count }}</a>
      </span>
      <span slot="action" slot-scope="text, record">
        <template v-if="record.log_count!==0 && record.success_log_count === 0 && record.fail_log_count === 0">
          <a @click="openDbModal(record)">更新</a>
        </template>
        <a-divider type="vertical" v-if="record.log_count!==0 && record.success_log_count === 0 && record.fail_log_count === 0" />
        <template>
          <a :href="record.file_url">下载</a>
        </template>
        <a-divider type="vertical" v-if="record.success_log_count === 0 && record.fail_log_count === 0"/>
        <template v-if="record.success_log_count === 0 && record.fail_log_count === 0">
          <a-popconfirm title="确定删除文件？" @confirm="deleteSql(record.sql_id)">
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 添加抽屉 -->
    <addDrawer v-if="addDrawerVisible" :visible="addDrawerVisible" @hide="handelAddDrawer" @finish="finish"></addDrawer>
    <a-modal
      width="750px"
      title="数据库更新"
      :visible="dbVisible"
      v-if="dbVisible"
      @ok="handleDbOk"
      @cancel="dbVisible = false"
      :confirmLoading="confirmLoading"
    >
      已选择SQL文件：{{ sqlName }}
      <p style="margin-top:10px;margin-bottom:10px;">更新内容：</p>
      <a-textarea v-model="sqlContent" :rows="12" />
    </a-modal>
    <viewDrawer v-if="viewDrawerVisible" :visible="viewDrawerVisible" :sqlDetail="sqlDetail" @hide="handelViewDrawer"></viewDrawer>
  </a-card>
</template>
<script>
import { getPre, getSqlList, postDeleteSql, batchSyncDatabase } from '@/api/sql'
import {
  getSqlInfo
} from '@/api/tenant'
import { TcgTable } from '@/components'
import addDrawer from './addDrawer'
import viewDrawer from './viewDrawer'
import _ from 'lodash'
const keyWordTypeDict = [
  // {
  //   id: 'name',
  //   name: '租户名称'
  // },
  // {
  //   id: 'code',
  //   name: '租户编号'
  // }
]
export default {
  components: {
    TcgTable,
    addDrawer,
    viewDrawer
  },
  data () {
    return {
      // 添加抽屉状态开关
      addDrawerVisible: false,
      viewDrawerVisible: false,
      // id
      id: '',
      // 关键字搜索类型列表
      keyWordTypeDict,
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        // status: '',
        // keyWordType: 'name',
        // keyWord: ''
      },
      // 表头
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          width: '60px'
        },
        {
          title: '文件名称',
          dataIndex: 'name',
          width: '200px'
        },
        // {
        //   title: '文件路径',
        //   dataIndex: 'sql_path',
        //   width: '200px'
        // },
        {
          title: '类型',
          dataIndex: 'sql_type',
          scopedSlots: { customRender: 'sql_type' },
          width: '100px'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '180px'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '300px'
        },
        {
          title: '成功 / 失败 / 全部',
          dataIndex: 'log_count',
          scopedSlots: { customRender: 'log_count' },
          width: '150px'
        },
        {
          title: '上传人',
          dataIndex: 'admin_account',
          width: '120px'
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '150px'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getSqlList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      dbVisible: false,
      sqlId: '',
      sqlName: '',
      sqlContent: '',
      confirmLoading: false,
      sqlDetail: {}
    }
  },
  created () {
    this.handelPre()
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: '',
        keyWordType: 'name',
        keyWord: ''
      }
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    // 完成创建
    finish () {
      this.handelAddDrawer()
      this.$refs.table.refresh(true)
    },
    // 打开添加抽屉
    openAddDrawer () {
      this.addDrawerVisible = true
    },
    // 关闭添加抽屉
    handelAddDrawer () {
      this.addDrawerVisible = false
    },
    openLogDrawer (record) {
      this.sqlDetail = record
      this.viewDrawerVisible = true
    },
    handelViewDrawer () {
      this.$refs.table.refresh(true)
      this.viewDrawerVisible = false
    },
    // 删除事件
    deleteSql (id) {
      postDeleteSql(id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('删除成功')
          this.$refs.table.refresh(true)
        }
      })
    },
    openDbModal (record) {
      this.sqlId = record.sql_id
      this.sqlName = record.name
      this.sqlContent = ''
      this.handleSqlChange()
      this.dbVisible = true
    },
    handleSqlChange () {
      // 获取sql文件信息
      getSqlInfo({ sql_id: this.sqlId }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.sqlContent = _.get(res, 'data.content', '')
        }
      })
    },
    handleDbOk () {
      const data = {
        sql_id: this.sqlId
      }
      this.confirmLoading = true
      batchSyncDatabase(data).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.$refs.table.refresh(true)
          this.confirmLoading = false
          this.dbVisible = false
        } else {
          // this.$message.error(res.message)
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
